import { Observable } from "rxjs";
import { MatchDetail } from "@app/core/match/domain/model/match-detail";
import { Match } from "@app/core/match/domain/model/match";
import { MatchSearchCriteria } from "@app/core/match/domain/match-search-criteria";
import { PaginatedResponse } from "@app/core/shared/domain/paginated-response";
import { MatchPaymentInfo } from "@app/core/match/domain/model/match-payment-info";
import { MatchCompareResponse } from "../data/network/match-compare.ws";
import { ShareStatistics } from "./model/share-statistics";
import { MatchCustomNameUpdateResponse } from "@app/core/shared/domain/api-types-filtered";

/**
 * Repository used to get match detail.
 */
export abstract class MatchRepo {
  /**
   * Get match detail.
   * @param matchId
   * @param token user token authentication
   */
  abstract getMatchDetail(
    matchId: string,
    token: string
  ): Observable<MatchDetail>;

  abstract getMatchCompare(
    matchId: string,
    token: string
  ): Observable<MatchCompareResponse>;

  abstract getMatchDetailSample(token: string | null): Observable<MatchDetail>;

  abstract getMatchCompareSample(
    token: string | null
  ): Observable<MatchCompareResponse>;

  abstract getMatches(
    matchSearchCriteria: MatchSearchCriteria,
    token: string
  ): Observable<PaginatedResponse<Match[]>>;

  abstract isPlayerAlreadySelectedInMatch(
    matchId: string,
    token: string
  ): Observable<boolean>;

  abstract getPublicVideoLink(
    matchId: string,
    type: "short" | "extended",
    token: string
  ): Observable<string>;

  abstract getMatchPaymentInfo(
    matchId: string,
    token: string
  ): Observable<MatchPaymentInfo>;

  abstract shareStatistics(
    matchId: string,
    token: string
  ): Observable<ShareStatistics>;

  abstract getSharedStatistics(
    playerId: string,
    token: string | null
  ): Observable<MatchDetail>;

  abstract setCompetitive(
    pk: string,
    competitive: boolean,
    token: string
  ): Observable<void>;

  abstract leaveMatch(matchId: string, token: string): Observable<void>;

  abstract editMatchName(
    match_code: string,
    custom_name: string,
    token: string
  ): Observable<MatchCustomNameUpdateResponse>;
}
